import { Navigate } from 'react-router-dom';
import { useDashboard } from '@/queries/useDashboard';
import { AppraisalsSection, HappinessSurveySection, MyDetailsSection, MyPastEvaluationSection, ToDoSection } from '@/components/dashboard';
import { useAuthStore } from '@/stores/useAuthStore';
import { paths } from '@/routes/paths';

export function DashboardPage() {
  const permissions = useAuthStore((state) => state.permissions);
  const globalRoles = permissions?.globalRoles ?? [];
  const displayRules = permissions?.displayRules;
  const isHROrStaffing = globalRoles.some((r) => r === 'HR' || r === 'Staffing');

  const { data } = useDashboard();

  if (isHROrStaffing) {
    return <Navigate to={paths.staffingActivities.occerSearch} replace />;
  }

  return (
    <>
      {data?.details && <MyDetailsSection myDetails={data.details} />}
      {data?.happinessSurvey && (
        <HappinessSurveySection
          completionRate={data.happinessSurvey.completionRate}
          surveys={data.happinessSurvey.surveys}
        />
      )}
      <ToDoSection
        jobEnds={data?.jobEnds ?? []}
        seniorFeedback={data?.seniorFeedback ?? []}
        qualtricsForm={data?.qualtricsForm ?? []}
      />
      {displayRules?.showAppraisalsSection && (
        <AppraisalsSection
          myAppraisal={data?.myAppraisal ?? null}
          collation={data?.collation ?? []}
          plannedInterviews={data?.plannedInterviews ?? []}
          talentCommittees={data?.talentCommittees ?? []}
        />
      )}
      <MyPastEvaluationSection
        pastEvaluations={data?.pastEvaluations ?? []}
        appraisals={data?.appraisals ?? []}
        showPastAppraisals={displayRules?.showPastAppraisals ?? true}
      />
    </>
  );
}

export default DashboardPage;
